import axios from '~/plugins/axios'

export default {

  async fetchUsers ({commit}, params) {
    const {data} = await axios.get('/api/admin/usuarios', {params: params})
    commit('updateList', data)
  }
}
